// API Configuration
//export const API_URL = process.env.REACT_APP_API_URI || 'http://localhost:3002';
export const API_URL = process.env.REACT_APP_API_URI || 'https://codeitronics-app.onrender.com';
// Other configuration constants can be added here
export const APP_NAME = 'CodeITronics';
export const APP_VERSION = '1.0.0'; 